import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import I18nBackend from "./services/i18nBackend";

i18n
  .use(I18nBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    ns: ["common", "System"],
    fallbackLng: "en",
    defaultNS: "common",
    fallbackNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    lng: localStorage.getItem("i18nextLng") || "en",
  });

if (typeof window !== "undefined") window.i18n = i18n;
export default i18n;
